// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgScheduleCancelledIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9 5a1 1 0 0 1-2 0V3a1 1 0 0 1 2 0z" />
    <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2z" />
    <path d="M17 5a1 1 0 1 1-2 0V3a1 1 0 1 1 2 0z" />
    <path
      fillRule="evenodd"
      d="M22 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10h20zm-7.293-6.707a1 1 0 0 0-1.414 0L12 14.586l-1.293-1.293a1 1 0 1 0-1.414 1.414L10.586 16l-1.293 1.293a1 1 0 1 0 1.414 1.414L12 17.414l1.293 1.293a1 1 0 1 0 1.414-1.414L13.414 16l1.293-1.293a1 1 0 0 0 0-1.414"
      clipRule="evenodd"
    />
  </g>
);
export default SvgScheduleCancelledIcon;
SvgScheduleCancelledIcon.displayName = 'SvgScheduleCancelledIcon';
